import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import {
  AddOrUpdateChoiceGroupRequestSchema,
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from '.././client-sdk/api';

export const useChoiceGroupApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createChoiceGroup = useCallback(
    async (choiceGroup: AddOrUpdateChoiceGroupRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addChoiceGroup(choiceGroup);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllChoiceGroup = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllChoiceGroups(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.storeId,
          undefined,
          undefined,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleChoiceGroupStatus(
          toggleSubAdminStatusRequest
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteChoiceGroup = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteChoiceGroups(deleteSubAdmins);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editChoiceGroup = useCallback(
    async (id: any, subAdminData: AddOrUpdateChoiceGroupRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editChoiceGroup(id, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    createChoiceGroup,
    getAllChoiceGroup,
    loading,
    error,
    getToggleStatus,
    deleteChoiceGroup,
    editChoiceGroup,
  };
};
